@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/breakpoints/breakpoints' as *;

.tabLines {
  [data-tab-header] {
    margin-left: -20px;
    margin-right: -20px;
    padding: 0 20px;
    border-bottom: solid 1px var(--border-default);
  }

  @include respond-to('max-xl') {
    overflow: visible;

    [data-tab-header] {
      width: calc(100% + var(--content-padding) * 2);
      margin-left: calc(var(--content-padding) * -1);
      margin-right: 0;
      padding: 0 var(--content-padding);
    }
  }

  [data-tab] {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }

  [data-tab-button] {
    white-space: nowrap;
    @include typography-v2-ui-sm;
    padding: 8px 4px;
  }
}
